import { toast } from "react-toastify";
import {
  fetchStockinCreationPOStart,
  fetchStockinCreationPOSuccess,
  fetchStockinCreationPOFailure,
} from "./reducer";

import { STOCK_IN_CREATION_PO } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const stockinCreationPO =
  (referenceId, jsonObj, setLoading, onSuccess) =>
  async (dispatch) => {
    dispatch(fetchStockinCreationPOStart());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        STOCK_IN_CREATION_PO(referenceId),
        "POST",
        jsonObj
      );

      if (response?.error) {
        dispatch(
          fetchStockinCreationPOFailure(response.error.message)
        );
        toast.error(response.error.message);
      } else {
        dispatch(fetchStockinCreationPOSuccess(response));
        dispatch(setSuccessMessage(true));
        toast.success("Product has been stocked in successfully");
        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(
        fetchStockinCreationPOFailure("Something went wrong")
      );
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };